export default __webpack_public_path__ + "static/AdobeStock-6477dad74d10fa54dbb2fa545db7ddae.png";